<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="pubGroupIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" style="color: #2e2e2e" @click="urlTo('pubGroupIndex')">公示公开</a> / <span>{{title}}明细</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper" style="width: 1200px;">
          <div class="advice">
          <div class="publicity"  style="width: 1100px;padding-left: 50px;">
          <div style="padding-top: 50px;padding-left: 5px;font-size: 15px">
            <a>公示名称：{{pubDesc}}</a>  <a style="padding-left: 70px">公示单位：{{pubParty}}</a><a style="padding-left: 70px">公示时间：{{beginDate}}至{{endDate}}</a>
          </div>
            <el-divider></el-divider>
           <!-- <div class="nav">
              <ul>
                <li><a href="javascript:void(0)" id="apply" class="on" @click="handleClick('apply','pay')">待遇申请</a></li>
                <li><a href="javascript:void(0)" id="pay" @click="handleClick('pay','apply')">资金发放</a></li>
              </ul>
            </div>-->
            <div class="" style="white-space:nowrap;color: #2e2e2e" >
        	<span>区划：
          <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   clearable placeholder="请选择区划" style="width: 180px;margin-right: 10px;"></el-cascader>
          <!--<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="办事单位" style="width: 180px;display: none"></el-cascader>-->
          </span>
              <span  v-if="tabSelect=='apply'" style="margin-left: 15px;">待遇类别：
           <el-cascader :options="dylbOption" v-model="selecteddylbOption" clearable  placeholder="待遇类别" style="width: 120px;" ></el-cascader></span>
              <span style="margin-left: 15px;display: none" v-if="tabSelect=='pay'">补贴项目：
                <el-cascader :options="dylbOption" v-model="selecteddylbOption" clearable  placeholder="补贴项目" style="width: 120px;" ></el-cascader></span>
              <span style="margin-left: 15px;">姓名：<el-input v-model="pname" placeholder="请输入姓名" clearable style="width: 130px;"></el-input></span>
              <span style="margin-left: 15px;" >身份证：<el-input v-model="userId" placeholder="请输入身份证号" clearable style="width: 200px;"></el-input></span>

              <span style="padding-left: 15px;"><el-button type="danger" @click="initData('yes')" icon="el-icon-search">搜索</el-button></span>
            </div>
            <div style="height: 10px"><a>&nbsp;</a></div>
            <table style="margin-top: 10px"  width="100%" border="0" cellspacing="1" cellpadding="0" v-if="tabSelect=='apply'">
              <tr class="first">
                <td >区划</td>
                <td >姓名</td>
                <td >身份证号</td>
                <td >待遇类别</td>
                <td >公示期间</td>
                <td width="60">申报原因</td>
                <td width="60">操作</td>
              </tr>

              <tr v-for="(item,index) in dataList" :key="item.itemId">
                <td align="left" nowrap="true">&nbsp; {{item.areaName}}/{{item.partyName}}</td>
                <!--<td align="left" nowrap="true">&nbsp; </td>-->
                <td align="center" nowrap="true">{{item.personName}}</td>
                <td align="center" nowrap="true">{{item.personUid}}</td>
                <td nowrap="true">&nbsp; {{item.archiveTypeCode}}</td>
                <td align="center" nowrap="true">{{item.beginTime}} 至 {{item.endTime}}</td>
                <td><el-popover
                  offset="400"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                 >
                  <div style="line-height: 30px;border-bottom: 1px solid #eaeff7;font-size: 14px;"><span style="font-weight: 600">户籍地址：</span>{{item.regiAddress}}</div>
                  <div style="line-height: 22px;border-bottom: 1px solid #eaeff7;font-size: 14px;margin-top: 5px;"><span style="font-weight: 600">申请原因：</span>{{item.reqReason}}</div>
                  <el-button slot="reference">原因</el-button> </el-popover></td>
                <td align="center" nowrap="true">
               <a href="javascript:void(0)"
                  @click="urlTo('/suggest',{applyId:item.itemId,partyId:item.partyId,title:'投诉',type:1,source:3})" class="complaint">投诉</a></td>
              </tr>
            </table >
            <table style="margin-top: 10px" width="100%" border="0" cellspacing="1" cellpadding="0" v-if="tabSelect=='pay'">
              <tr class="first">
                <td >区划</td>

                <td >姓名</td>
                <td >身份证号</td>
                <td >补贴项目</td>
                <td >实发合计(元)</td>
                <td >发放日期</td>
                <td width="60">操作</td>
              </tr>
              <tr v-for="(item,index) in dataList" :key="item.itemId">
                <td align="left" nowrap="true">&nbsp; {{item.areaName}}/ {{item.partyName}}</td>
                <td align="center" nowrap="true">{{item.personName}}</td>
                <td align="center" nowrap="true">{{item.personUid}}</td>
                <td nowrap="true">{{item.className}}</td>
                <td align="center" nowrap="true">{{item.amount}}</td>
                <td align="center" nowrap="true">{{item.payDate}}</td>
                <td align="center" nowrap="true">
                  <a href="javascript:void(0)"  @click="urlTo('/suggest_ts',{up_id:item.itemId,partyId:item.partyId,title:'投诉',type:1})" class="complaint">投诉</a></td>
              </tr>
            </table >
            <div style="text-align: center;height: 50px;line-height: 50px;" v-if="dataList.length>0"> <el-pagination
              layout="prev, pager, next"
              :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
            </el-pagination>
            </div></div>
          </div>
        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
let id = 0;

export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      userId:'',
      pubDesc:'',
      pubParty:'',
      pubPartyId:'',
      beginDate:'',
      endDate:'',
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      sj_str:'',
      pubId:'',
      week_str:'',
      tabSelect:'apply',
      pageTotal:1,
      dataList:[],
      pname:"",
      payMonth:"",
      title:'',
      selectedRegion:[],
      selecteddepartOption:[],
      selecteddylbOption:[],
      departOption:[],
      dylbOption:[
        { value: 'BLAN', label: '城乡低保' },
        { value: 'CLP_LIV', label: '残疾人生活补贴' },
        { value: 'CLP_HLF', label: '残疾人护理补贴' },
        { value: 'NTF', label: '特困供养' },
        { value: 'TEMP', label: '临时救助' },
        { value: 'BLAN_ORP', label: '事实无人抚养儿童生活费' },
        { value: 'ORP', label: '分散养育孤儿' },
        { value: 'CUTTED', label: '精简退职' },
        { value: 'QYTC', label: '分散养育孤儿' },
        { value: 'ORP', label: '起义投诚' },
      ],
      props: {
        lazy: true,
        checkStrictly:true,
        lazyLoad (node, resolve) { const { level } = node;
          var t=0;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
            t=1;
            //上级为空，默认设置大通县数据
          }
          const options={pid:node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
            const nodes =[];
            // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
            // }else{
            //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
            //   resolve(nodes);
            // }
          })
        }
      },
      pageNum:1,
      pageSize:10,
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
    // selectedRegion(nv){
    //   // this.getDepartAreas(nv[nv.length-1],0);
    // }
  },
  created(){
    var type = this.$route.query.type;
    var typeCode = this.$route.query.typeCode;
    this.endDate = this.$route.query.endDate;
    this.beginDate = this.$route.query.beginDate;
    this.pubParty = this.$route.query.pubParty;
    this.pubDesc = this.$route.query.pubDesc;
    this.pubPartyId=this.$route.query.pubPartyId;
    //1代表apply，2代表资金发放
    // if (type===1 || type==='apply' || type ==='1'){
    //   this.handleClick('apply','pay')
    //   this.title='待遇申请'
    // }else {
      this.handleClick('pay','apply')
      this.title='资金发放'
    // }
    this.pubId = this.$route.query.pubId;
    this.initData();

  },
  methods: {
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    initData(tts){
      if(tts){
        this.pageNum=1;
      }
      var departId="";
      if(this.selectedRegion && this.selectedRegion.length>0){
        departId=this.selectedRegion[this.selectedRegion.length-1];
      }
      // if(this.selecteddepartOption && this.selecteddepartOption.length>0){
      //   departId=this.selecteddepartOption[0];
      // }
     var archive_type_code="";
      if(this.selecteddylbOption && this.selecteddylbOption.length>0){
        archive_type_code=this.selecteddylbOption[0];
      }

      if(!this.payMonth || this.payMonth=='null'){
        this.payMonth='';
      }
      const options={
        userId:this.userId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
        pubTypeId:this.tabSelect,
        workDepartId:departId,
        pname:this.pname,
        pubId:this.pubId,
        payMonth:this.payMonth,
        archive_type_code:archive_type_code
      }
      var t=this;
      this.$https.post("api/pubItem/getPubItemList.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.itemData && response.data.data.itemData.length>0){
            t.dataList=response.data.data.itemData;
          }else {
            t.dataList=[]
          }
          t.pageTotal=response.data.data.allPageSize;
        } else {
          // t.departOption =[];
        }
      })
    },
    getContent(content_title,pub_id){
      this.pub_id=pub_id;
      this.pageNum2=1;
      this.loading_item=false;
      this.finished_item=false;
      this.error_item=false;

      const options={
        pubId:this.pub_id,
        itemMonth:this.itemMonth,
        pageNum:this.pageNum2,
        pageSize:this.pageSize2
      };
      this.content_show=true;
      // this.content_title="公示人员名单"
      //查询明细数据
      var tt=this;
      this.$https.post("api/pubItem/getPubItemInfoPage.do",options,response=>{
        if (response.status === 200 && response.data.code===200 && null != response.data.data) {
          tt.pageNum2=tt.pageNum2+1;
          if(null != response.data.data && response.data.data.itemData && response.data.data.itemData.length>0){
            tt.itemData=response.data.data;
            tt.itemListss=response.data.data.itemData;
            // t.dataObjList.push(response.data.data);
            tt.loading_item = false;
            if(response.data.data.itemData.length<tt.pageSize2){
              tt.finished_item = true;
            }
          }else{
            tt.loading_item = false;
            tt.finished_item = true;
          }
          tt.error_item=false;
        } else {
          tt.error_item=true;
        }
      })
    },
  getDepartAreas(ParentId,index){
    const options={pid:ParentId}
    var t=this;
    this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
      if (response.status === 200 && response.data.code===200) {
        t.departOption = Object.values(response.data.data).map(function(e){
          return {label:e.name,value:e.code,leaf:true}
        })
      } else {
        t.departOption =[];
      }
    })
  },
    handleClick(ontab,untab) {
      //异步获取数据
      if(this.tabSelect==ontab) {
        return;
      }
      this.tabSelect=ontab;
      $("#"+ontab).addClass("on");
      $("#"+untab).removeClass("on");
      if(ontab !='pay'){
        this.payMonth='';
      }
      if(ontab !='apply'){
        this.selecteddylbOption=[];
      }
      this.pageNum=1;

    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/PubItemIndex.vue